module.exports = __webpack_public_path__ + "static/media/get_app-24px.bef20ae9.svg";